import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	viewMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewMore: {
		id: 'compass-common.scorecards-health-lozenge.popup-content.view-more',
		defaultMessage: 'View more',
		description: 'Button shown to allow users to view more scorecards.',
	},
});
export default messages;
